import React from "react";
import VideoBg from "./video-bg.png";
import logo from "./home-jb-logo.png";
import Note from "../Typography/Note";
import HomepageVideo from "../HomepageVideo";
import HomepageFAQ from "../HomepageFAQ";
import Heading3 from "../Typography/Heading3";
import OutboundLink from "../OutboundLink";

const Homepage = () => {
  return (
    <>
      <section
        className="pa3 pa5-l sans-serif"
        style={{ backgroundImage: `url(${VideoBg})` }}
      >
        <header className="flex justify-between items-center mw8-and-half center">
          <div style={{ width: "11rem" }}>
            <img className="h-auto" src={logo} />
          </div>
          <div>
            <a href="/signin" className="link bg-black white pv2 ph3 br2 fw7">
              Sign back in
            </a>
          </div>
        </header>
        <div className="w-60-l tc mw8-and-half center flex justify-center flex-wrap mt5 mb6">
          <h1
            className="lh-title mt0 sans-serif fw7 black mb3"
            style={{ fontSize: "2.75em" }}
          >
            Transform your data into insights that move people
          </h1>
          <Heading3>
            <OutboundLink
              text="Learn More"
              underline={true}
              href="https://www.juiceanalytics.com/"
            />
            &nbsp; or &nbsp;
            <a className="black-90 underline fw6" href="/signin">
              Sign back in
            </a>
          </Heading3>
        </div>
        <HomepageVideo />
      </section>
      <section className="pa3 pa5-l pb7-l bg-white" id="faq">
        <HomepageFAQ />
      </section>
      <footer className="pa3 pa5-l bg-black flex justify-center">
        <Note color="white-50">
          &copy; Juice Analytics. All rights reserved.{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="link underline white-50"
            href="https://www.juiceanalytics.com/acceptable-use"
          >
            Acceptable Use Policy
          </a>
          <span> | </span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="link underline white-50"
            href="https://www.juiceanalytics.com/privacy"
          >
            Privacy Policy
          </a>
          <span> | </span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="link underline white-50"
            href="https://www.juiceanalytics.com/terms-of-use"
          >
            Terms of Use
          </a>
        </Note>
      </footer>
    </>
  );
};

export default Homepage;
